// src/background.js

// Toàn bộ mã JavaScript của hiệu ứng nền (canvas, particles, ripples, mouse, init, animate, Particle class, v.v.)
// đã từng nằm trong thẻ <script> của index.html.txt

const canvas = document.getElementById('background-canvas');
const ctx = canvas.getContext('2d');
canvas.width = window.innerWidth;
canvas.height = window.innerHeight;

let particlesArray = [];
let ripplesArray = [];
const mouse = { x: null, y: null, radius: 150 };
window.addEventListener('mousemove', function(event) {
    mouse.x = event.x;
    mouse.y = event.y;
});
window.addEventListener('mouseout', function() {
    mouse.x = null;
    mouse.y = null;
});
window.addEventListener('click', function(event) {
    mouse.x = event.x;
    mouse.y = event.y;
    ripplesArray.push({ x: mouse.x, y: mouse.y, radius: 5, maxRadius: 100, speed: 0.8, opacity: 1, lineWidth: 3 });
});
class Particle {
    constructor(x, y, directionX, directionY, size, color) {
        this.x = x; this.y = y; this.directionX = directionX; this.directionY = directionY; this.size = size; this.color = color;
    }
    draw() { ctx.beginPath(); ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2, false); ctx.fillStyle = this.color; ctx.fill(); }
    update() {
        if (this.x > canvas.width || this.x < 0) { this.directionX = -this.directionX; }
        if (this.y > canvas.height || this.y < 0) { this.directionY = -this.directionY; }
        this.x += this.directionX; this.y += this.directionY; this.draw();
    }
}
function initBackgroundParticles() { // Đổi tên hàm init để tránh xung đột
    particlesArray = [];
    let numberOfParticles = (canvas.height * canvas.width) / 3500;
    for (let i = 0; i < numberOfParticles; i++) {
        let size = (Math.random() * 2) + 1;
        let x = (Math.random() * ((innerWidth - size * 2) - (size * 2)) + size * 2);
        let y = (Math.random() * ((innerHeight - size * 2) - (size * 2)) + size * 2);
        let directionX = (Math.random() * 0.4) - 0.2;
        let directionY = (Math.random() * 0.4) - 0.2;
        let color = 'rgba(60, 72, 88, 0.7)';
        particlesArray.push(new Particle(x, y, directionX, directionY, size, color));
    }
}
function connectParticles() { // Đổi tên hàm connect
    let opacityValue = 1;
    const connectDistSquare = 110 * 110;
    const mouseRadiusSquare = mouse.radius * mouse.radius;
    for (let a = 0; a < particlesArray.length; a++) {
        if (mouse.x != null && mouse.y != null) {
            let distanceToMouse = ((particlesArray[a].x - mouse.x) * (particlesArray[a].x - mouse.x)) + ((particlesArray[a].y - mouse.y) * (particlesArray[a].y - mouse.y));
            if (distanceToMouse < mouseRadiusSquare) {
                opacityValue = 1 - (distanceToMouse / mouseRadiusSquare);
                ctx.strokeStyle = `rgba(0, 123, 255, ${opacityValue})`; ctx.lineWidth = 1.5; ctx.beginPath(); ctx.moveTo(particlesArray[a].x, particlesArray[a].y); ctx.lineTo(mouse.x, mouse.y); ctx.stroke();
            }
        }
        for (let b = a; b < particlesArray.length; b++) {
            let distance = ((particlesArray[a].x - particlesArray[b].x) * (particlesArray[a].x - particlesArray[b].x)) + ((particlesArray[a].y - particlesArray[b].y) * (particlesArray[a].y - particlesArray[b].y));
            if (distance < connectDistSquare) {
                opacityValue = 1 - (distance / connectDistSquare);
                ctx.strokeStyle = `rgba(60, 72, 88, ${opacityValue})`; ctx.lineWidth = 0.8; ctx.beginPath(); ctx.moveTo(particlesArray[a].x, particlesArray[a].y); ctx.lineTo(particlesArray[b].x, particlesArray[b].y); ctx.stroke();
            }
        }
    }
}
function handleBackgroundRipples() { // Đổi tên hàm handleRipples
    for (let i = ripplesArray.length - 1; i >= 0; i--) {
        const r = ripplesArray[i];
        r.radius += r.speed; r.lineWidth -= 0.04;
        if (r.radius > r.maxRadius || r.lineWidth <= 0) { ripplesArray.splice(i, 1); }
        else { ctx.beginPath(); ctx.arc(r.x, r.y, r.radius, 0, Math.PI * 2); const opacity = 1 - (r.radius / r.maxRadius); ctx.strokeStyle = `rgba(0, 191, 255, ${opacity})`; ctx.lineWidth = r.lineWidth; ctx.stroke(); }
    }
}
function drawBackgroundMouseGlow() { // Đổi tên hàm drawMouseGlow
    if (mouse.x === null) return;
    const glowRadius = 70;
    const gradient = ctx.createRadialGradient(mouse.x, mouse.y, 0, mouse.x, mouse.y, glowRadius);
    gradient.addColorStop(0, 'rgba(0, 191, 255, 0.25)'); gradient.addColorStop(1, 'rgba(0, 191, 255, 0)');
    ctx.beginPath(); ctx.arc(mouse.x, mouse.y, glowRadius, 0, Math.PI * 2); ctx.fillStyle = gradient; ctx.fill();
}
function animateBackground() { // Đổi tên hàm animate
    requestAnimationFrame(animateBackground); ctx.clearRect(0,0,innerWidth, innerHeight);
    for (let i = 0; i < particlesArray.length; i++) { particlesArray[i].update(); }
    connectParticles(); drawBackgroundMouseGlow(); handleBackgroundRipples();
}

// Hàm khởi tạo chính cho background
export function initCanvasBackground() { // Export hàm này để main.js có thể gọi
    // Thêm listener cho resize ở đây
    window.addEventListener('resize', function() {
        canvas.width = innerWidth; canvas.height = innerHeight; initBackgroundParticles();
    });
    initBackgroundParticles();
    animateBackground();
}